import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import NotFound from "../pages/404";
import Home from "../pages/Home";
import Products from "../pages/Products";
import Insights from "../pages/Insights";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Services from "../pages/Services";
import SingleService from "../pages/SingleService";
import SingleProduct from "../pages/SingleProduct";
import SingleInsight from "../pages/SingleInsight";
import AdLandingPage from "../pages/ads/AdLandingPage";

export const HomeRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/home" element={<Navigate to="/" replace />} />

      <Route element={<MainLayout />}>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* Services */}
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<SingleService />} />

        {/* Products */}
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<SingleProduct />} />

        {/* Insights / Blog */}
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<SingleInsight />} />

        {/* Ads Landing Pages */}
        <Route path="/start" element={<AdLandingPage />} />
      </Route>
    </Routes>
  );
};

export default HomeRoutes;
